import { z } from 'zod';
import { addPublishWindowIssues, adminMetadataSchema, contentStatusChangeSchema, nonEmptyUpdate, publishWindowShape, } from './common.js';
const faqEditableShape = {
    question: z.string().min(1),
    answer: z.string().min(1),
    category: z.string().min(1),
    keywords: z.array(z.string().min(1)),
};
const faqWriteShape = { ...faqEditableShape, ...publishWindowShape };
export const createFaqSchema = z
    .object({
    question: faqEditableShape.question,
    answer: faqEditableShape.answer,
    category: faqEditableShape.category,
    keywords: faqEditableShape.keywords.optional(),
    status: publishWindowShape.status.optional(),
    publishAt: publishWindowShape.publishAt.optional(),
    unpublishAt: publishWindowShape.unpublishAt.optional(),
})
    .superRefine(addPublishWindowIssues);
export const updateFaqSchema = nonEmptyUpdate(z.object(faqWriteShape));
export const faqStatusChangeSchema = contentStatusChangeSchema;
export const publicFaqSchema = z.object({
    question: faqEditableShape.question,
    answer: faqEditableShape.answer,
    category: faqEditableShape.category,
});
export const publicFaqListSchema = z.array(publicFaqSchema);
export const publicFaqFields = Object.freeze(Object.keys(publicFaqSchema.shape));
export const adminFaqSchema = z
    .object({ id: z.number().int().positive(), ...faqWriteShape })
    .extend(adminMetadataSchema.shape);
export const adminFaqListSchema = z.array(adminFaqSchema);
export const faqPreviewSchema = z.object({
    content: publicFaqSchema,
    effectiveVisibility: adminMetadataSchema.shape.effectiveVisibility,
    publishAt: publishWindowShape.publishAt,
    unpublishAt: publishWindowShape.unpublishAt,
});
//# sourceMappingURL=faqs.js.map